export const QA_NAME_DOC_FLOW_SELECT_MODAL = 'docFlowSelectModal'

export const QA_NAME_DOC_FLOW_SELECT_MODAL_CONNECT = 'docFlowSelectModalConnect'

export const QA_NAME_DOC_FLOW_SELECT_MODAL_DISCONNECT =
  'docFlowSelectModalDisconnect'

export const DOC_FLOW_SELECT_MODAL_NOTIFICATION_ID = {
  limitInfo: 'doc-flow-request-links-limit-info',
}
